<template>
  <div id="app">
    <div class="touxiang">
      <h1>2022新年头像生成器</h1>
      
      <div class="tx-main">
        <div class="printMe" ref="printMe">
          <img class="tx-profile" :src="profile"/>
          <img class="tx-cover" :src="cover"/>
        </div>
      </div>
      <div class="tx-actions">
        <a href="javascript:;" class="btn btn-round btn-info" @click="onUploadFile" ><i class="mdi mdi-upload"></i> 上传您的头像</a>
        <input type="file" class="tx-file" ref="txFile" @change="onFileChange" accept="image/*">
        <a href="javascript:;" class="btn btn-round btn-success" @click="onCreateProfile" ><i class="mdi mdi-creation"></i> 生成新头像</a>
      </div>

      <p class="text-center">选择样式</p>
      <div class="tx-covers">
          <div v-for="(item,index) in covers" :key="index" class="tx-main " :class="index==coversIndex ? 'active' : ''" @click="onCoverChange(index)">
              <img class="tx-profile" :src="profile"/>
              <img class="tx-cover" :src="'/static/images/nian/' + item.name"/>
              <div class="tx-title">{{item.title}}</div>
          </div>
      </div>

      <div class="alert alert-info tx-tip">
        <strong><i class="mdi mdi-24px mdi-spin mdi-star"></i> 本工具优点</strong>
        <p>上传你的头像后，点击样式自动生成头像，可帮助您快速在头像上添加新年气氛素材，实现在线新年头像制作一键生成。</p>
        <p class="text-center">
          <img src="/static/images/nian/2weima.png" style="width:200px;" alt="手机扫码制作头像"/>
          <br/><br/>扫码制作头像
        </p>
      </div>

    
    </div>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  },
  data:function() {
   
		return {
      profile:'/static/images/nian/profile.png',
      cover:'/static/images/nian/cover2.png',
      output:'',
      coversIndex:0,
      covers:[
        {
          name:'cover2.png',
          title:'72周年',
        },{
          name:'cover1.png',
          title:'72周年',
        },
        {
          name:'cover3.png',
          title:'72周年',
        },
        {
          name:'cover4.png',
          title:'72周年',
        },
        {
          name:'cover5.png',
          title:'72周年',
        },
        {
          name:'cover6.png',
          title:'72周年',
        },
        {
          name:'cover7.png',
          title:'72周年',
        },
        {
          name:'cover8.png',
          title:'72周年',
        },
        {
          name:'cover9.png',
          title:'72周年',
        },
        {
          name:'cover10.png',
          title:'72周年',
        },
        {
          name:'cover11.png',
          title:'72周年',
        },
        {
          name:'cover12.png',
          title:'72周年',
        },
        // {
        //   name:'cover14.png',
        //   title:'72周年',
        // },
        // {
        //   name:'cover16.png',
        //   title:'72周年',
        // },
        {
          name:'cover17.png',
          title:'72周年',
        },
        // {
        //   name:'cover18.png',
        //   title:'72周年',
        // },
        
      ]
		};
	},
  watch: {
  
  },
	mounted:function(){
    //bind domain
    // if(!location.hostname.match(/ima.co/) && !location.hostname.match(/zqrcode.c/) && !location.hostname.match(/zqrhk.c/)){
    //   location.href = 'https://www.2weima.com/?diysafe='+ encodeURIComponent(location.href);
    //   $('body').html('');
    //   return ;
    // }
    Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    this.$nextTick(() => {
      this.init();
    });


	},
	methods: {
    
		init:function(){
    
     

		},
    onUploadFile:function(){
      // document.getElementById('file').click();
      this.$refs.txFile.dispatchEvent(new MouseEvent('click')) 
    },
    onFileChange:function(event){
      var that =this;
      
      var file = this.$refs.txFile.files[0];
      if(!file){
        return ;
      }

      var reader = new FileReader();
      var imgUrlBase64 = reader.readAsDataURL(file);
      reader.onload = function (e) {
        that.profile = reader.result
      }


    },
    onCreateProfile:async function(){
        const el = this.$refs.printMe;
        const options = {
          type: 'dataURL'
        }
        this.output = await this.$html2canvas(el, options);
        $common.dialog('<div  class="text-center"><img  src="'+this.output+'"/></div>','green','长按保存头像',false);
    },
    onCoverChange:function(index){
      this.coversIndex = index;
      this.cover = '/static/images/nian/' + this.covers[index].name;
      this.onCreateProfile();
    }
    
	}
}
</script>


<style scoped>
.touxiang h1{
  font-size: 22px;
  text-align: center;
}
.tx-main{
  background:#fff;
  width:320px;
  height: 320px;
  border: 10px solid #fce4c6;
  border-radius: 15px;
  margin:30px auto;
  position:relative;
  overflow: hidden;

}
.printMe{
  width:300px;
  height:300px;
  overflow: hidden;
}
.tx-profile{
  width: 100%;
  height: 100%;
}
.tx-cover{
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
}
.tx-actions{
  width:375px;
  margin:20px auto;
  text-align: center;
}
.tx-actions a.btn{
  margin:0 3px;
}
.tx-file{
  display: none;
}
.tx-covers {
 display: flex;
 flex-wrap: wrap;
 max-width: 750px;
 margin:0 auto;
}
.tx-covers .tx-main{
  width:120px;
  height:120px;
  border: 5px solid rgb(238, 208, 250);
  border-radius: 5px;
  margin:10px auto;
  /* float: left; */
}
.tx-title{
  margin-top:5px;
  font-size:12px;
  color: #666;
}
.tx-covers .tx-main.active{
   border: 5px solid rgb(177, 30, 235);
}
.tx-tip{
 max-width: 750px;
 margin:20px auto;

}
</style>
